namespace SP {
    export function typeInTextarea(text: string, el: any = document.activeElement) {
        if (!el.setRangeText) return;
        const [start, end] = [el.selectionStart, el.selectionEnd];
        el.setRangeText(text, start, end, 'select');
        var event = new Event('input');
        el.dispatchEvent(event);
    }
}